export const getPartnerProjectDetailsPath = (
  partnerId: number,
  projectName: string
): string =>
  `/partner/${partnerId}/dashboard/projects/${encodeURIComponent(projectName)}`;
